import { useSelector } from 'react-redux';

export default function useAnonymousMode() {
  const mentor = useSelector((state) => state.mentors.mentor);
  const urlParams = new URLSearchParams(window.location.search);

  const urlAnonymous = urlParams.get('mode') === 'anonymous';
  if (mentor?.settings) {
    return mentor?.settings?.allow_anonymous || urlAnonymous;
  } else {
    return urlAnonymous;
  }
}
